var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextReview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37936 12.6219C1.20571 12.6229 1.03569 12.5722 0.89098 12.4762C0.746269 12.3802 0.633425 12.2433 0.566834 12.0829C0.500243 11.9225 0.482922 11.7459 0.51708 11.5757C0.551238 11.4054 0.635326 11.2492 0.758625 11.1269L5.3923 6.50194L0.758625 1.87701C0.593995 1.71238 0.501507 1.48909 0.501507 1.25627C0.501507 1.14099 0.524214 1.02684 0.56833 0.920332C0.612446 0.813826 0.677109 0.717052 0.758625 0.635536C0.840142 0.554019 0.936915 0.489357 1.04342 0.445241C1.14993 0.401125 1.26408 0.378418 1.37936 0.378418C1.61218 0.378418 1.83547 0.470906 2.0001 0.635536L7.24577 5.8812C7.4086 6.04501 7.5 6.2666 7.5 6.49757C7.5 6.72854 7.4086 6.95013 7.24577 7.11393L2.0001 12.3596C1.91913 12.4422 1.82257 12.5079 1.71602 12.5529C1.60946 12.598 1.49504 12.6214 1.37936 12.6219Z",
    fill: "#171719"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextReview);
export default __webpack_public_path__ + "static/media/nextReview.4d416434520cc20d30d9f52600053cb9.svg";
export { ForwardRef as ReactComponent };